"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fonts = {
    heading: 'sofia-pro, sans-serif',
    body: 'sofia-pro, sans-serif',
};
exports.default = fonts;
